// extracted by mini-css-extract-plugin
export default {"faq_container":"Faq_faq_container__NtLC3","faq_list":"Faq_faq_list__gsXir"};